
import { Link } from "react-router-dom";
import { useTheme } from "@/hooks/useTheme";
import { Moon, Sun, ThumbsUp } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useSession } from "@/hooks/useSession";

const NavBar = () => {
  const { theme, setTheme } = useTheme();
  const session = useSession();

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-background/80 backdrop-blur-sm border-b">
      <div className="container mx-auto px-4 h-16 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Link to="/" className="font-semibold text-xl text-primary">
            PricePal
          </Link>
        </div>
        
        <div className="flex items-center gap-4">
          <Link
            to="/"
            className="text-sm text-muted-foreground hover:text-foreground transition-colors flex items-center gap-1"
          >
            <ThumbsUp size={16} />
            Recommendations
          </Link>
          <Link
            to="/wishlist"
            className="text-sm text-muted-foreground hover:text-foreground transition-colors"
          >
            Wishlist
          </Link>
          {session && (
            <Link
              to="/account"
              className="text-sm text-muted-foreground hover:text-foreground transition-colors"
            >
              Account
            </Link>
          )}
          <Button
            variant="ghost"
            size="sm"
            onClick={() => setTheme(theme === "light" ? "dark" : "light")}
          >
            {theme === "light" ? <Moon size={16} /> : <Sun size={16} />}
          </Button>
        </div>
      </div>
    </nav>
  );
};

export default NavBar;
